import React, { useState } from "react";
import { Images } from "../../Assets/Index";
import { Button, Form, Input, Spin } from "antd";
import { userLoginWithPassword } from "../../ApiServices/Apifun";
import { NavLink, useNavigate } from "react-router-dom";
import { dispatchtoast, setLocalStorageItem } from "../../Utils";
import { BiLockAlt, BiMobile } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const isValidPhone = /^\d{10}$/.test(mobile);

  const handleLogin = (val) => {
    setLoading(true);
    const payload = {
      mobile: val.mobile,
      password: val.password,
    };

    userLoginWithPassword(payload)
      .then((res) => {
        if (res.status) {
          setLocalStorageItem("isLoggedIn", true);
          setLocalStorageItem("accessToken", res.access_token);
          setLocalStorageItem("user", res?.user);
          setLocalStorageItem("is_new_user", res?.is_new_user);
          dispatchtoast(res.message || "Login successful");
          navigate("/allGame");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Spin spinning={loading}>
        <div className="flex h-screen justify-center items-left">
          <div className="flex relative shadow-lg mx-8 bg-black shadow-red-500 rounded-lg justify-center  items-center flex-col px-10 md:px-18 py-20">
            <img src={Images.Logo} className="w-[300px] " alt="Chandni Chowk Matka" />
            <div className="text-start">
              <p className="mt-2 text-white text-2xl font-normal custome">
                Welcome Back
              </p>
              <p className="mt-2 text-white font-thin custome">
                It's easy to start playing on Chandni Chowk Matka. Enter your
              </p>

              <p className=" text-white font-thin custome">
                mobile number and password to continue.
              </p>
            </div>

            <div className="mt-12 w-full flex flex-col items-center">
              <Form
                form={form}
                className="w-full"
                onFinish={(val) => handleLogin(val)}
                onFinishFailed={(err) => console.log(err)}
              >
                <Form.Item
                  name={"mobile"}
                  className="m-0"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter mobile number",
                    },
                    {
                      pattern: /^\d{10}$/,
                      message: "Enter a valid 10 digit mobile number",
                    },
                  ]}
                >
                  <Input
                    prefix={
                      <BiMobile className="text-gray-400 font-bold text-2xl" />
                    }
                    suffix={
                      isValidPhone && (
                        <FaCheckCircle className="text-red-600 text-xl" />
                      )
                    }
                    className="bg-black hover:bg-black shadow-sm shadow-[#a6a6a6] text-white focus:bg-black rounded-2xl border-none"
                    placeholder="Enter Mobile Number"
                    onChange={(e) => setMobile(e.target.value)}
                    value={mobile}
                    maxLength={10}
                  />
                </Form.Item>

                <Form.Item
                  name={"password"}
                  className="mt-4"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={
                      <BiLockAlt className="text-gray-400 font-bold text-2xl" />
                    }
                    className="custom-placeholder bg-black text-white hover:bg-black shadow-sm shadow-[#a6a6a6] rounded-2xl border-none"
                    placeholder="Enter Password"
                  />
                </Form.Item>

                <Form.Item className="w-full text-center" labelCol={{ span: 24 }}>
                  <Button
                    loading={loading}
                    type="default"
                    htmlType="submit"
                    className="w-3/4 m-8 custome rounded-3xl h-10 font-medium text-lg border-none
                   text-white bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f]
                   hover:bg-gradient-to-r hover:from-[#734e0c] hover:via-[#ba7d13] hover:to-[#e9a52f]"
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>

              <NavLink to={"/register"}>
                <p className="m-0 custome text-sm text-white cursor-pointer">
                  Don't have an account?{" "}
                  <span className="text-yellow-300 font-semibold">Sign Up</span>
                </p>
              </NavLink>
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default Login;
